import React, { useEffect, useState } from "react";
import { Select } from "antd";
import type { SelectProps } from "antd";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { mainUrl } from "../../helpers/constants";

let currentValue: string;

const fetch = async (
  value: string,
  callback: Function,
  setLoading: (loading: boolean) => void
) => {
  currentValue = value;

  if (value) {
    const instance = axios.create({
      baseURL: mainUrl,
      headers: { "Content-Type": "application/json" },
    });
    if (currentValue === value && value.length > 3) {
      try {
        setLoading(true);
        const res = await instance.get<any>(`api/v1/county/sug?q=${value}`);
        if (res.data.status === "success") {
          const data = res.data.counties.map((item: any) => ({
            value: item[1],
            text: item[0],
          }));
          callback(data);
        }
      } catch (error) {
        console.error("Error loading counties:", error);
        callback([]);
      } finally {
        setLoading(false);
      }
    }
  } else {
    callback([]);
  }
};

const SearchInput: React.FC<{
  placeholder: string;
  currentSearchParams?: { [param: string]: string };
}> = (props) => {
  let [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState<SelectProps["options"]>([]);
  const [value, setValue] = useState<string[]>();
  const [isLoading, setIsLoading] = useState(false);

  const handleSearch = (newValue: string) => {
    fetch(newValue, setData, setIsLoading);
  };

  const handleChange = (newValue: string[]) => {
    setValue(newValue);
    if (newValue.length > 0) {
      setSearchParams({
        ...props.currentSearchParams,
        county: newValue.toString(),
      });
    } else {
      searchParams.delete("county");
      setSearchParams(searchParams);
    }
  };

  return (
    <Select
      style={{ minWidth: 120 }}
      size="small"
      showSearch
      mode="multiple"
      value={value}
      placeholder={props.placeholder}
      defaultActiveFirstOption={false}
      suffixIcon={null}
      filterOption={false}
      onSearch={handleSearch}
      onChange={handleChange}
      loading={isLoading}
      notFoundContent={isLoading ? "Loading..." : "No results"}
      options={(data || []).map((d) => ({
        value: d.value,
        label: d.text,
      }))}
    />
  );
};

interface IProps {
  currentSearchParams?: { [param: string]: string };
}

export const SearchCountyInput = ({ currentSearchParams }: IProps) => (
  <SearchInput placeholder="County" currentSearchParams={currentSearchParams} />
);
